import { type Dispatch, useEffect } from 'react';
import PortalLoadingElement from '../../../../components/PortalLoadingElement';
import { JourneyStage } from '../../StandardApplicationEntrypoint/Journey/JourneyController';
import { type Action, type State } from '../../StandardApplicationEntrypoint/Journey/reducer';
import { type EventApplicationState } from './JourneyController';

export const getStageFromApplication = (
    application: State<EventApplicationState>['application'],
    initialized = true
) => {
    const { draftFlow, deposit, signing, module } = application;
    if (module.__typename !== 'EventApplicationModule') {
        throw new Error('ModuleType not supported ');
    }
    if (!initialized && application.withCustomerDevice) {
        // todo render calculator
    }

    if (!draftFlow.isApplicantKYCCompleted) {
        return JourneyStage.ApplicantKYC;
    }

    if (!draftFlow.areGlobalAgreementsCompleted) {
        return JourneyStage.Unknown;
    }

    if (draftFlow.hasGuarantor && !draftFlow.isGuarantorCompleted) {
        return JourneyStage.GuarantorKYC;
    }

    if (deposit && !draftFlow.isDepositCompleted && !draftFlow.isDepositSkipped) {
        return JourneyStage.Deposit;
    }

    if (signing && !draftFlow.isSigningCompleted) {
        switch (signing.__typename) {
            case 'ApplicationNamirialSigning':
                return JourneyStage.Namirial;

            case 'ApplicationOTPSigning':
                return JourneyStage.Otp;

            default:
                return JourneyStage.Unknown;
        }
    }

    return JourneyStage.Unknown;
};

export type InitializeStageProps = {
    state: State<EventApplicationState>;
    dispatch: Dispatch<Action<EventApplicationState>>;
};

const InitializeStage = ({ state, dispatch }: InitializeStageProps) => {
    const { application } = state;

    useEffect(() => {
        dispatch({ type: 'goTo', stage: getStageFromApplication(application) });
    }, [application, dispatch]);

    return <PortalLoadingElement />;
};

export default InitializeStage;
